import {AgChartTheme} from 'ag-charts-enterprise'

//CSS vars doesnt seem to work here. Until we find a better solution, hardcoded / copied values from daisy theme --color-base-content
const theme = 'ag-default'
export const agChartProLight: AgChartTheme = {
    baseTheme: theme,
    params: {
        foregroundColor: '#2f3438'
    }
}

export const agChartProDark: AgChartTheme = {
    baseTheme: `${theme}-dark`,
    params: {
        foregroundColor: '#d5d5d5'
    }
}